import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./Num05.module.scss";

export const Num05Icon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path fill="#000" d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" opacity="0.6"></path>
      <path fill="#fff" d="M17.289 18.532c0-.329-.074-.618-.221-.867-.147-.26-.402-.476-.765-.646-.363-.17-.85-.3-1.462-.391-.612-.09-1.383-.136-2.312-.136a71.72 71.72 0 00.306-3.213c.08-1.088.142-2.108.187-3.06h6.375v2.125h-4.25c-.023.408-.051.805-.085 1.19-.023.374-.051.703-.085.986 1.655.113 2.873.504 3.655 1.173.793.657 1.19 1.575 1.19 2.754a3.91 3.91 0 01-.29 1.513 3.253 3.253 0 01-.866 1.207c-.385.34-.873.606-1.462.799-.578.193-1.258.289-2.04.289a7.35 7.35 0 01-.97-.068 9.086 9.086 0 01-.968-.153 10.354 10.354 0 01-.833-.187 3.272 3.272 0 01-.578-.204l.459-2.091c.283.125.657.25 1.122.374.465.113 1.02.17 1.666.17.782 0 1.349-.153 1.7-.459.351-.317.527-.686.527-1.105z2_Родная литература (русская)_1.png"></path>
    </svg>
  );
};
